import BaseRepository from '@/api/BaseRepository';
import Actuator from '@/models/Actuator';
import Project from '@/models/Project';
import Revision from '@/models/Revision';

export default class ActuatorRepository extends BaseRepository {

    private actuatorRoute = 'actuator';

    public async getAllActuators(projectId: string): Promise<any> {
        return this.axiosClient.get(`${this.actuatorRoute}/getAll/${projectId}`);
    }

    public async getActuator(actuatorId: string): Promise<any> {
        return this.axiosClient.get(`${this.actuatorRoute}/${actuatorId}`);
    }

    public async createActuator(project: Project, revision: Revision | undefined, actuator: Actuator): Promise<any> {
        const payload = {
            project: project.id,
            revision: revision?.id,
            actuator: {
                pos: actuator.pos,
                posCustomer: actuator.posCustomer,
                tag: actuator.tag,
                quantity: actuator.quantity,
                valveSize: actuator.valveSize,
                valveClass: actuator.valveClass,
                driveType: actuator.driveType,
                controlType: actuator.controlType,
                driveTypeA: actuator.driveTypeA,
                selectedDriveTypeAOptions: actuator.selectedDriveTypeAOptions,
                pressureMin: actuator.pressureMin,
                pressureNorm: actuator.pressureNorm,
                pressureMax: actuator.pressureMax,
                safetyFunctionByPowerFailure: actuator.safetyFunctionByPowerFailure,
                safetyFunctionByPressFailure: actuator.safetyFunctionByPressFailure,
                bto: actuator.bto,
                eto: actuator.eto,
                btc: actuator.btc,
                etc: actuator.etc,
                running: actuator.running,
                runningOut: actuator.runningOut,
                btoAngle: actuator.btoAngle,
                etoAngle: actuator.etoAngle,
                btcAngle: actuator.btcAngle,
                etcAngle: actuator.etcAngle,
                runningAngle: actuator.runningAngle,
                runningOutAngle: actuator.runningOutAngle,
                btoSecFac: actuator.btoSecFac,
                runningSecFac: actuator.runningSecFac,
                etoSecFac: actuator.etoSecFac,
                btcSecFac: actuator.btcSecFac,
                runningOutSecFac: actuator.runningOutSecFac,
                etcSecFac: actuator.etcSecFac,

                strokeTimeOpen: actuator.strokeTimeOpen,
                strokeTimeClose: actuator.strokeTimeClose,
                strokeTimeOpenMOD: actuator.strokeTimeOpenMOD,
                strokeTimeCloseMOD: actuator.strokeTimeCloseMOD,
                controlFunction: actuator.controlFunction,
                torques: actuator.torques,

                valveMast: actuator.valveMast,

                mast: actuator.mast,
                tolerance: actuator.tolerance,
                items: actuator.items,
                label: actuator.label,
                zylinderVolumenP: actuator.zylinderVolumenP,
                myInterpretation: actuator.myInterpretation,
                temperature: actuator.temperature,
                manuelOverride: actuator.manuelOverride
            }
        };
        return this.axiosClient.post(`${this.actuatorRoute}`, payload);
    }

    public async updateActuator(actuator: Actuator): Promise<any> {
        const payload = {
            pos: actuator.pos,
            posCustomer: actuator.posCustomer,
            tag: actuator.tag,
            quantity: actuator.quantity,
            valveSize: actuator.valveSize,
            valveClass: actuator.valveClass,
            valveMast: actuator.valveMast,
            driveType: actuator.driveType,
            controlType: actuator.controlType,
            driveTypeA: actuator.driveTypeA,
            selectedDriveTypeAOptions: actuator.selectedDriveTypeAOptions,
            pressureMin: actuator.pressureMin,
            pressureNorm: actuator.pressureNorm,
            pressureMax: actuator.pressureMax,
            bto: actuator.bto,
            eto: actuator.eto,
            btc: actuator.btc,
            etc: actuator.etc,
            running: actuator.running,
            runningOut: actuator.runningOut,
            btoAngle: actuator.btoAngle,
            etoAngle: actuator.etoAngle,
            btcAngle: actuator.btcAngle,
            etcAngle: actuator.etcAngle,
            runningAngle: actuator.runningAngle,
            runningOutAngle: actuator.runningOutAngle,

            btoSecFac: actuator.btoSecFac,
            runningSecFac: actuator.runningSecFac,
            etoSecFac: actuator.etoSecFac,
            btcSecFac: actuator.btcSecFac,
            runningOutSecFac: actuator.runningOutSecFac,
            etcSecFac: actuator.etcSecFac,

            strokeTimeOpen: actuator.strokeTimeOpen,
            strokeTimeClose: actuator.strokeTimeClose,
            strokeTimeOpenMOD: actuator.strokeTimeOpenMOD,
            strokeTimeCloseMOD: actuator.strokeTimeCloseMOD,
            controlFunction: actuator.controlFunction,
            torques: actuator.torques,

            mast: actuator.mast,
            tolerance: actuator.tolerance,
            items: actuator.items,
            label: actuator.label,
            zylinderVolumenP: actuator.zylinderVolumenP,
            myInterpretation: actuator.myInterpretation,
            temperature: actuator.temperature,
            manuelOverride: actuator.manuelOverride
        };
        return this.axiosClient.patch(`${this.actuatorRoute}/${actuator.id}`, payload);
    }

    public async deleteActuator(actuatorId: string): Promise<any> {
        return this.axiosClient.delete(`${this.actuatorRoute}/${actuatorId}`);
    }
}
